<widget-card
    [cardTitle]="widgetConfig.translations.widgetTitle"
    [showPeriod]="true"
    [actionLabel]="
        savings !== null && actionLabel && widgetConfig.dataSource !== widgetDataSourceEnum.BUILDING_INDICATOR_YEAR ? actionLabel : null
    "
    (actionClick)="onActionClick()"
>
    @let budgetColor = savings | applyPureFunction: getBudgetColor$ | async;
    <developer-helper [datasourceCode]="dataSourceCode" />

    @if (!isLoading && !loadingError && computedData?.reference !== 0 && computedData?.recorded! + computedData?.estimated! !== 0) {
        <div class="grid-container landing-summary-grid">
            <div class="min-width">
                <highcharts-chart [options]="chartConfig$ | async" [autoReflow]="true" />
            </div>
            <div class="right-col">
                <div class="savings">
                    @if (savings! >= 0) {
                        <div class="text-success text-center">
                            <svg-icon class="svg-icon-size" src="assets/icons/thumbs-up.svg" [svgStyle]="{ fill: budgetColor }" />
                            <br />
                            {{
                                widgetConfig.translations.estimatedSavings
                                    | interpolate: { savings: savings! | formatUnit: savingsValueFormatter }
                            }}
                            <br />
                            {{
                                'WIDGET.BUDGET_VISION.SO_PERCENT' | translate: { percent: savingsPercent | significantDigits | localnumber }
                            }}
                        </div>
                    } @else {
                        <div class="text-danger text-center">
                            <svg-icon class="svg-icon-size" src="assets/icons/alert.svg" [svgStyle]="{ fill: budgetColor }" />
                            <br />
                            {{
                                widgetConfig.translations.estimatedExceeding
                                    | interpolate: { exceeding: -savings! | formatUnit: savingsValueFormatter }
                            }}
                            <br />
                            {{
                                'WIDGET.BUDGET_VISION.SO_PERCENT'
                                    | translate: { percent: -savingsPercent! | significantDigits | localnumber }
                            }}
                        </div>
                    }
                </div>
                <div class="custom-legend">
                    @if (computedData?.recorded) {
                        <div class="legend-item">
                            <div class="symbol spending-recorded"></div>
                            <div class="series-name">{{ widgetConfig.translations.recordedConsumption }}</div>
                        </div>
                    }
                    @if (computedData?.estimated) {
                        <div class="legend-item">
                            <div class="symbol spending-estimated"></div>
                            <div class="series-name">
                                {{ widgetConfig.translations.estimatedConsumption }}
                            </div>
                        </div>
                    }
                    @if (computedData?.reference) {
                        <div class="legend-item">
                            <div class="symbol" [style.backgroundColor]="budgetColor"></div>
                            <div class="series-name">{{ widgetConfig.translations.reference }}</div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    @if (
        !isLoading &&
        !loadingError &&
        (!computedData || computedData.reference === 0 || (computedData.recorded ?? 0) + (computedData.estimated ?? 0) === 0)
    ) {
        <div class="no-data medium-padding">
            <svg-icon src="assets/icons/home/feed.svg" />
            <h2>{{ 'WIDGET.BUDGET_VISION.NO_REFERENCE' | translate }}</h2>
            <p>{{ 'WIDGET.BUDGET_VISION.NO_REFERENCE_DESCRIPTION' | translate }}</p>
            @if (isCostTimeseriesIndicator && (canAccessToBudget$ | async)) {
                <button ui-button color="primary" class="no-print" (click)="navigateToBudget()">
                    {{ 'WIDGET.BUDGET_VISION.GO_TO_BUDGET' | translate }}
                </button>
            }
        </div>
    }

    <loading-and-error [isLoading]="isLoading" [hasError]="loadingError" />
</widget-card>
